import { render, staticRenderFns } from "./newTransfer.vue?vue&type=template&id=6ea58eb8&scoped=true"
import script from "./newTransfer.vue?vue&type=script&lang=js"
export * from "./newTransfer.vue?vue&type=script&lang=js"
import style0 from "./newTransfer.vue?vue&type=style&index=0&id=6ea58eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea58eb8",
  null
  
)

export default component.exports